// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.car__item {
    border: 1px solid #7c8a9736;
    padding: 20px;
    border-radius: 5px;
}
.car__item-info span i {
    color: #FF7F50;
    font-size: 1.1rem;
}
.car__item-btn a {
    text-decoration: none;
    color: #fff;
    font-weight: 500;;
}
.car__item-btn a:hover {
    color: #fff;
}
.car__item-btn {
    border-radius: 0;
    border: none;
    outline: none;
    background: #a9a1a1;
    padding: 8px 0px;
}
.car__btn-details {
    background: #FF7F50;
    border-radius: 0px 4px 4px 0px;
}
.car__btn-rent {
    border-radius: 4px 0px 4px 0px;
}
.car__item-content h4 {
    font-size: 1rem;
}
.car__item-content h6 {
    font-size: 1.2rem;
    font-weight: 600;
}
@media only screen and (max-width: 992px) {
    .car__item h4 {
        font-size: 1.1rem;
        margin-bottom: 0;
    }
    .car__item h6 {
        font-size: 1rem;
        margin-top: 10px;
    }
    .car__item-info {
        flex-wrap: wrap;
    }
    .car__item-info span {
        font-size: 0.8rem;
        justify-content: space-between;
    }
    .car__item-btn {
        padding: 5px 10px;
        font-size: 0.9rem;
    }
}
@media only screen and (max-width: 768px) {
    .car__item h4 {
        font-size: 1rem;
    }
    .car__item h6 {
        font-size: 0.9rem;
    }
    .car__item-info span {
        font-size: 0.7rem;
    }
    .car__item-info span i {
        font-size: 0.9rem;
    }
    .car__item-btn {
        font-size: 0.8rem;
    }

}

.car__img {
    height: 170px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/car-item.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,8BAA8B;IAClC;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;;AAEJ;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".car__item {\n    border: 1px solid #7c8a9736;\n    padding: 20px;\n    border-radius: 5px;\n}\n.car__item-info span i {\n    color: #FF7F50;\n    font-size: 1.1rem;\n}\n.car__item-btn a {\n    text-decoration: none;\n    color: #fff;\n    font-weight: 500;;\n}\n.car__item-btn a:hover {\n    color: #fff;\n}\n.car__item-btn {\n    border-radius: 0;\n    border: none;\n    outline: none;\n    background: #a9a1a1;\n    padding: 8px 0px;\n}\n.car__btn-details {\n    background: #FF7F50;\n    border-radius: 0px 4px 4px 0px;\n}\n.car__btn-rent {\n    border-radius: 4px 0px 4px 0px;\n}\n.car__item-content h4 {\n    font-size: 1rem;\n}\n.car__item-content h6 {\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n@media only screen and (max-width: 992px) {\n    .car__item h4 {\n        font-size: 1.1rem;\n        margin-bottom: 0;\n    }\n    .car__item h6 {\n        font-size: 1rem;\n        margin-top: 10px;\n    }\n    .car__item-info {\n        flex-wrap: wrap;\n    }\n    .car__item-info span {\n        font-size: 0.8rem;\n        justify-content: space-between;\n    }\n    .car__item-btn {\n        padding: 5px 10px;\n        font-size: 0.9rem;\n    }\n}\n@media only screen and (max-width: 768px) {\n    .car__item h4 {\n        font-size: 1rem;\n    }\n    .car__item h6 {\n        font-size: 0.9rem;\n    }\n    .car__item-info span {\n        font-size: 0.7rem;\n    }\n    .car__item-info span i {\n        font-size: 0.9rem;\n    }\n    .car__item-btn {\n        font-size: 0.8rem;\n    }\n\n}\n\n.car__img {\n    height: 170px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
